module.exports = __webpack_public_path__ + "img/filter_add.bb15ff5f.png";